import React, { FC } from 'react'
import Radio from '@vtex/styleguide/lib/Radio'

interface SelectorRadioProps {
  disabled: boolean
  checked: boolean
}

type Props = SelectorRadioProps

const SelectorRadio: FC<Props> = (props: Props) => (
  <div className="flex flex-column justify-center items-center mr4 mr5-ns mr6-l scale-150-ns no-margin-parent">
    <Radio {...props} />
  </div>
)

export default SelectorRadio
